export class ClusterLayer {
    static create (options) {
        let _force = false;
        try {
            _force = options.symbology.cluster.force;
        } catch (err) {
            console.log(err);
        }

        const clusterOptions = {
            disableClusteringAtZoom: 15,
            animate: false,
            polygonOptions: {
                color: '#e74c3c',
                fillColor: '#e74c3c',
                fillOpacity: 0.5,
                strokeWeight: 2,
                opacity: 1,
                weight: 1
            },
            maxClusterRadius: options.controlRange || 70,
            singleMarkerMode: _force
        };

        try {
            if (options.symbology.cluster.disableAtZoom) {
                clusterOptions.disableClusteringAtZoom = options.symbology.cluster.disableAtZoom;
            }
        } catch (err) {
            console.log('disableClusteringAtZoom value is 15');
        }

        if ((options.symbology.cluster || {}).template) {
            clusterOptions.iconCreateFunction = options.symbology.cluster.template;
        }

        // Create a cluster layer
        return L.markerClusterGroup(clusterOptions);
    }
}



// WEBPACK FOOTER //
// ./src/scripts/layers/Leaflet/VectorLayer/ClusterLayer.js